import { get } from "lodash";
import { Tooltip, Box, Typography } from "@material-ui/core";
const {
  default: UserProfileWidget
} = require("Components/widgets/UserProfileWidget");

const CreatedBy = ({colProps}) => (
  <td>
    <Tooltip title={get(colProps, "dataItem.fullName", "") || ""}>
      <Box display="flex" alignItems={"center"}>
        <UserProfileWidget
          firstName={get(colProps, "dataItem.createdByUser.firstName", "")}
          lastName={get(colProps, "dataItem.createdByUser.lastName", "")}
          url={get(
            colProps,
            "dataItem.createdByUser.profileImage.fileName",
            ""
          )}
        />
        <Typography variant="body2" className="font-13">
          {get(colProps, "dataItem.fullName", "") || ""}
        </Typography>
      </Box>
    </Tooltip>
  </td>
);

export default CreatedBy;
